module.exports = __webpack_public_path__ + "resources/img/img_i_onenet2_en.752c99f82395966a71f82eeca4fb94d0.png";